import { Directive, ElementRef } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[layoutColumn]'
})
export class LayoutColumnDirective {
    public static cls = 'layout-column';

    constructor(private elementRef: ElementRef) {
        (elementRef.nativeElement as HTMLElement).classList.add(LayoutColumnDirective.cls);
    }
}
